module.exports = __webpack_public_path__ + "static/img/reference pics_canada pool.05df7f62.jpg";